export enum UploadProcessSection {
  Medication = 'MEDICATION',
  Lab = 'LAB',
  Scan = 'SCAN',
}
